import type { Query } from '@Types/Base';

interface CreateProxyUrlParams {
  path: string;
  request: Query;
}

function createProxyUrl({ path, request }: CreateProxyUrlParams): string {
  const {
    language,
    region,
    proxyOrigin,
    allRegions,
    supportedLanguages,
    mainRegion,
    defaultLanguage,
  } = request;
  const [pathname, search = ''] = path.split('?');
  let chunks = pathname.split('/');

  // Формируем ссылку в которой мы гарантируем корректность выбранного языка и региона
  if (chunks[1] === 'backend') {
    // Удаляем из адреса регион/язык
    const filteredChunks = chunks.filter((chunk) => {
      return ![...allRegions, ...supportedLanguages, 'backend'].includes(chunk);
    });

    // Собираем заново в строго определенном порядке
    const regionSlug = region === mainRegion ? '' : region;
    const lang = language.slug === defaultLanguage ? '' : language.slug;
    chunks = ['', 'backend', lang, regionSlug, ...filteredChunks]
      .map((chunk) => (chunk || '').replace(/\//g, ''))
      .filter((chunk, index) => index === 0 || chunk !== '');
  }

  // Добавляем слэш после 'backend', иначе не пройдём по маске прокси
  if (chunks[chunks.length - 1] === 'backend') chunks.push('');

  const fullUrl = `${chunks.join('/')}${search ? `?${search}` : ''}`;
  const result = `${proxyOrigin}${fullUrl}`;

  return result;
}

export default createProxyUrl;
